/* This is the EMIS climate Change Component N.11 */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 43px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទការគ្រប់គ្រងកាកសំណល់
            </td>
            <td
              style="
                width: 150px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ចម្លើយជ្រើសរើស
            </td>
          </tr>
          <tr v-for="(item, index) in waste_label.length" :key="index">
            <td
              style="
                width: 102px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ waste_label[index] }}
            </td>
            <td
              style="
                width: 102px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                class="py-0 px-1"
                v-model="data[index].d"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, index)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- this is the last three questions 9, 10, 11 -->
    <!--
    <div>
      <v-card class="px-1 my-2" outlined tile>
        <v-row no-gutters align="center">
          <v-col cols="8">
            <p class="font-weight-bold">
              ៩.តើសាលារៀនមានកម្មវិធីឲ្យកូនសិស្សធ្វើសកម្មភាពរៀបចំសួនច្បារឬទេ?
            </p>
          </v-col>
          <v-col cols="4">
            <v-select
              class="px-1"
              v-model="other.garden_program"
              :items="yesNo2"
              item-text="text"
              item-value="value"
              @keypress.native="onSelect2($event, index)"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="px-1 my-2" outlined tile>
        <v-row no-gutters align="center">
          <v-col cols="8">
            <p class="font-weight-bold">
              ១០.តើសាលារៀនមានកម្មវិធីឲ្យកូនសិស្សដាំដើមឈើឡើងវិញឬទេ?
            </p>
          </v-col>
          <v-col cols="4">
            <v-select
              class="px-1"
              v-model="other.tree_planing_program"
              :items="yesNo2"
              item-text="text"
              item-value="value"
              @keypress.native="onSelect3($event, index)"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="px-1 my-2" outlined tile>
        <v-row no-gutters align="center">
          <v-col cols="8">
            <p class="font-weight-bold">
              ១១.តើសាលារៀនមានរៀបចំកម្មវិធីអាហារពេលព្រឹកដែរឬទេ?
            </p>
          </v-col>
          <v-col cols="4">
            <v-select
              class="px-1"
              v-model="other.breakfast"
              :items="yesNo2"
              item-text="text"
              item-value="value"
              @keypress.native="onSelect4($event, index)"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card>
    </div>
    -->
  </v-container>
</template>

<script>
import { waste_label, yesNo2 } from "@/utils/ascf/climateVariables.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      waste_label: waste_label,
      yesNo2: yesNo2,
    };
  },
  methods: {
    onSelect: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].d = charCode - 48;
        this.$forceUpdate();
      }
    },
    /*
    onSelect2: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.other.garden_program = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.other.tree_planing_program = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.other.breakfast = charCode - 48;
        this.$forceUpdate();
      }
    },
    */
  },
};
</script>

<style scoped>
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>